import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicSelectionService {
  private encryptionService = inject(EncryptionService);
  private selectedClinicIdSubject = new BehaviorSubject<number | null>(null);
  private selectedClinicNameSubject = new BehaviorSubject<string | null>(null);
  
  /**
   * Observable for the currently selected clinic ID.
   */
  public selectedClinicId$: Observable<number | null> = this.selectedClinicIdSubject.asObservable();
  
  /**
   * Observable for the currently selected clinic Name.
   */
  public selectedClinicName$: Observable<string | null> = this.selectedClinicNameSubject.asObservable();

  constructor() {
    const storedClinicId = this.encryptionService.getSessionItem('selectedClinicId');
    if (storedClinicId !== null && storedClinicId !== undefined) {
      this.selectedClinicIdSubject.next(Number(storedClinicId));
    }
    const storedClinicName = this.encryptionService.getSessionItem('selectedClinicName');
    if (storedClinicName) {
      this.selectedClinicNameSubject.next(storedClinicName);
    }
  }

  /**
   * Set the selected clinic ID and Name.
   */
  setClinicId(clinicId: number | null, clinicName?: string | null): void {
    if (clinicId !== null) {
      this.encryptionService.setSessionItem('selectedClinicId', clinicId);
      if (clinicName) {
        this.encryptionService.setSessionItem('selectedClinicName', clinicName);
      } else {
        this.encryptionService.removeSessionItem('selectedClinicName');
      }
    } else {
      this.encryptionService.removeSessionItem('selectedClinicId');
      this.encryptionService.removeSessionItem('selectedClinicName');
    }
    this.selectedClinicIdSubject.next(clinicId);
    this.selectedClinicNameSubject.next(clinicName || null);
  }

  /**
   * Get the current value of the selected clinic ID.
   */
  getClinicId(): number | null {
    return this.selectedClinicIdSubject.value;
  }
  
  /**
   * Get the current value of the selected clinic Name.
   */
  getClinicName(): string | null {
    return this.selectedClinicNameSubject.value;
  }
}
